import {getPrivateAxios} from '../../libs';
import {PaginatedQuery} from '../guides';
import {Collection} from './types';

export interface FetchCollectionParams {
  sort?: 'createdAt' | 'updatedAt' | 'name';
  page?: number;
  take?: number;
}

/**
 * Fetch guides with pagination
 * @param params
 */
export const fetchCollections = async (params: FetchCollectionParams) => {
  const {data} = await getPrivateAxios().get<PaginatedQuery<Collection>>('/collections', {
    params,
  });
  return data;
};
